const CustomerAPI = {
  customerDashboard: { url: '/customer-dashboard', method: 'POST' },
  homepage: { url: '/homepage', method: 'POST' },
  headerFooter: { url: '/header-footer', method: 'POST' },
  liveUpdates: { url: '/live-updates', method: 'POST' },
  // product
  productFilters: { url: '/product-filter-items', method: 'POST' },
  productList: { url: '/product-listing', method: 'POST' },
  productDetails: { url: '/product-details', method: 'POST' },
  productMakeOffer: { url: '/make-offer', method: 'POST' },
  notifyMeForStock: { url: '/stock-notification', method: 'POST' },
  // FFL Review
  fflReviewListing: { url: '/ffl-review-listing', method: 'POST' },
  addFFLReview: { url: '/ffl-review', method: 'POST' },
  fflReviewDetail: { url: '/ffl-review-info', method: 'POST' },
  likeUnlikeFFLReview: { url: '/ffl-review-like', method: 'POST' },
  // Product Review
  productReviewListing: { url: '/product-review-listing', method: 'POST' },
  addProductReview: { url: '/product-review', method: 'POST' },
  productReviewDetail: { url: '/product-review-info', method: 'POST' },
  likeUnlikeProductReview: { url: '/product-review-like', method: 'POST' },
  // Marketplace Review
  marketplaceReviewListing: { url: '/marketplace-review-listing', method: 'POST' },
  addMarketplaceReview: { url: '/marketplace-review', method: 'POST' },
  marketplaceReviewDetail: { url: '/marketplace-review-info', method: 'POST' },
  likeUnlikeMarketplaceReview: { url: '/marketplace-review-like', method: 'POST' },
  // Customer profile > reviews summary
  customerReviewCounter: { url: '/customer-review-counter', method: 'GET' },
  toReviewListing: { url: '/to-review-listing', method: 'POST' },
  reviewRepliesListing: { url: '/review-replies-listing', method: 'POST' },
  // Top FFL
  topFFLList: { url: '/registred-ffl-listing', method: 'POST' },
  // Following List
  followingList: { url: '/get-follow-ffl', method: 'POST' },
  followUnfollowFFL: { url: '/follow-ffl', method: 'POST' },
  // Wish List
  addToWishList: { url: '/wishlist', method: 'POST' },
  getWishList: { url: '/get-wishlist', method: 'POST' },
  removeFromWishList: { url: '/wishlist', method: 'DELETE' },
  // blog
  blogCommonForFeaturedAndCategory: { url: '/blog-common', method: 'GET' },
  blogList: { url: '/blog-listing', method: 'POST' },
  singleBlogInfo: { url: '/blog-details', method: 'POST' },
  subscribeNewsletter: { url: '/subscribe-newsletter', method: 'POST' },
  // compare
  compareList: { url: '/compare-products', method: 'POST' },
  addToCompare: { url: '/add-to-compare', method: 'POST' },
  removeFromCompare: { url: '/delete-compare-product', method: 'DELETE' },
  // cart
  cartList: { url: '/cart', method: 'POST' },
  addToCart: { url: '/add-to-cart', method: 'POST' },
  updateCartQty: { url: '/update-cart-item-quantity', method: 'PATCH' },
  deleteItemFromCart: { url: '/delete-cart-item', method: 'DELETE' },
  placeOrder: { url: '/place-order', method: 'POST' },
  checkoutCalculation: { url: '/checkout-calculation', method: 'POST' },
  validateProductCoupon: { url: '/validate-product-coupon', method: 'POST' },
  // address
  addressList: { url: '/get-customer-address', method: 'POST' },
  addAddress: { url: '/customer-address', method: 'POST' },
  singleAddressInfo: { url: '/get-customer-address-info', method: 'POST' },
  updateAddress: { url: '/customer-address', method: 'PATCH' },
  deleteAddress: { url: '/customer-address', method: 'DELETE' },
  // search FFL / FFL List
  fflListing: { url: '/ffl-listing', method: 'POST' },
  singleFFLInfo: { url: '/ffl-info', method: 'POST' },
  fflPublicCreds: { url: '/get-ffl-public-creds', method: 'POST' },
  applePayValidateMerchant: { url: '/apple-pay-validate-merchant', method: 'POST' },
  // TODO: remove with the Apple Pay debug logs - non-production API only
  applePayClientLog: { url: '/apple-pay-client-log', method: 'POST' },
  getSellMyFirearmsFaq: { url: '/get-faq', method: 'POST' },
  settings: { url: '/settings', method: 'POST' },
  gunForSale: { url: '/gun-for-sale', method: 'POST' },
  updateGunForSaleData: { url: '/gun-for-sale', method: 'PATCH' },
  gunsForSaleList: { url: '/customer-gun-for-sale', method: 'POST' },
  singleGunForSaleInfo: { url: '/get-gun-for-sale-info', method: 'POST' },
  markGunSold: { url: '/gun-for-sale-mark-as-sold', method: 'POST' },
  deleteGunForSale: { url: '/gun-for-sale', method: 'DELETE' },
  downloadGunPdf: { url: '/gun-for-sale-pdf', method: 'POST_BUFFER_DATA' },
  getGunForSaleLogs: { url: '/get-gun-for-sale-logs', method: 'POST' },

  // notification settings
  getNotificationSetting: { url: '/notification-settings', method: 'GET' },
  updateNotificationSetting: { url: '/notification-settings', method: 'PATCH' },
  sendOTP: { url: '/send-otp', method: 'POST' },
  verifyOTP: { url: '/verify-otp', method: 'POST' },
  // ffl
  approvedFFLList: { url: '/approved-ffl-listing', method: 'POST' },
  getOffers: { url: '/get-offers', method: 'POST' },
  helpAndSupport: { url: '/help-and-support', method: 'GET' },
  globalSearch: { url: '/global-search', method: 'POST' },
  fieldRequest: { url: '/field-request', method: 'POST' },
  // orders
  orderList: { url: '/customer-orders', method: 'POST' },
  requestReturnItem: { url: '/request-return-item', method: 'POST' },
  // content page
  getBySlugContentPageInfo: { url: '/get-by-slug-content-page-info', method: 'POST' },
};
export default CustomerAPI;
